export default __webpack_public_path__ + "static/media/user.2ff4a025.svg";